var React = require('react');

function XDecorativeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.0217 16.9996L31.8818 8.13942C33.5455 6.47573 33.5455 3.78146 31.8818 2.11777C30.2181 0.454072 27.5239 0.454072 25.8602 2.11777L17 10.9779L8.13991 2.11777C6.47622 0.454072 3.78195 0.454072 2.11825 2.11777C0.45456 3.78146 0.45456 6.47573 2.11825 8.13942L10.9784 16.9996L2.11825 25.8597C0.45456 27.5234 0.45456 30.2176 2.11825 31.8813C2.94834 32.7114 4.03871 33.13 5.12908 33.13C6.21945 33.13 7.3063 32.7149 8.13991 31.8813L17 23.0212L25.8602 31.8813C26.6903 32.7114 27.7806 33.13 28.871 33.13C29.9614 33.13 31.0482 32.7149 31.8818 31.8813C33.5455 30.2176 33.5455 27.5234 31.8818 25.8597L23.0217 16.9996Z","fill":"#EB4CAC"}));
}

XDecorativeInline.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 48 48","fill":"none"};

module.exports = XDecorativeInline;

XDecorativeInline.default = XDecorativeInline;
